import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/")({
  loader: () => {
    throw redirect({
      to: "/admin/users",
      search: {
        page: 1,
        sortBy: undefined,
        sortDir: undefined,
        accountType: undefined,
      },
    });
  },
});
